import { render, staticRenderFns } from "./NewArticles.vue?vue&type=template&id=191c8aa3&scoped=true"
import script from "./NewArticles.vue?vue&type=script&lang=js"
export * from "./NewArticles.vue?vue&type=script&lang=js"
import style0 from "./NewArticles.vue?vue&type=style&index=0&id=191c8aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c8aa3",
  null
  
)

export default component.exports